import { Listbox } from '@headlessui/react';
import { ChevronDown } from 'lucide-react';

interface Option {
  value: string;
  label: string;
}

interface CustomListboxProps {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  className?: string;
}

export default function CustomListbox({ value, onChange, options, placeholder = 'Sélectionner', className = '' }: CustomListboxProps) {
  const selectedOption = options.find(opt => opt.value === value);

  return (
    <Listbox value={value} onChange={onChange}>
      <div className={`relative ${className}`}>
        <Listbox.Button className="relative w-full px-3 py-2 bg-white border-2 border-black rounded-lg text-left text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-900 cursor-pointer">
          <span className="block truncate">
            {selectedOption?.label || placeholder}
          </span>
          <span className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <ChevronDown className="h-5 w-5 text-gray-400" />
          </span>
        </Listbox.Button>
        <Listbox.Options className="absolute z-50 mt-1 w-full bg-white border-2 border-black rounded-lg shadow-lg max-h-60 overflow-auto focus:outline-none">
          {options.map((option) => (
            <Listbox.Option
              key={option.value}
              value={option.value}
              className={({ active }) =>
                `cursor-pointer select-none relative py-2 px-3 ${
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                }`
              }
            >
              {({ selected }) => (
                <span className={selected ? 'font-medium' : 'font-normal'}>
                  {option.label}
                </span>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
}
